import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, currency = 'USD') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatNumber(num) {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1) + 'B';
  }
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K';
  }
  return num.toString();
}

export function formatPercent(value, decimals = 1) {
  return `${(value * 100).toFixed(decimals)}%`;
}

export function getRiskGradeColor(grade) {
  const colors = {
    'AAA': 'text-emerald-600 bg-emerald-50',
    'AA': 'text-emerald-500 bg-emerald-50',
    'A': 'text-green-600 bg-green-50',
    'BBB': 'text-green-500 bg-green-50',
    'BB': 'text-amber-600 bg-amber-50',
    'B': 'text-amber-500 bg-amber-50',
    'CCC': 'text-orange-600 bg-orange-50',
    'CC': 'text-orange-500 bg-orange-50',
    'C': 'text-red-600 bg-red-50',
    'D': 'text-red-700 bg-red-50',
  };
  return colors[grade] || 'text-slate-600 bg-slate-50';
}

export function getDecisionColor(decision) {
  const colors = {
    'APPROVE': 'text-emerald-600 bg-emerald-50 border-emerald-200',
    'CONDITIONAL_APPROVE': 'text-amber-600 bg-amber-50 border-amber-200',
    'DECLINE': 'text-red-600 bg-red-50 border-red-200',
  };
  return colors[decision] || 'text-slate-600 bg-slate-50 border-slate-200';
}

export function getSectorIcon(sector) {
  const icons = {
    'SME': 'Building2',
    'Trade Finance': 'Ship',
    'Agri-Finance': 'Wheat',
    'Project Finance': 'Landmark',
  };
  return icons[sector] || 'Briefcase';
}
